var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{directives:[{name:"ezuiDirectives",rawName:"v-ezuiDirectives",value:({
  src: _vm.src,
  player: _vm.player,
  setPlayer: _vm.setPlayer
}),expression:"{\n  src,\n  player,\n  setPlayer\n}"}],staticClass:"ezui-video-warp",attrs:{"autoplay":"","controls":_vm.config.showControl,"playsInline":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }